/* eslint-disable */
/** this file was copied as is from react-dev-utils/refreshOverlayInterop */

// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end
'use strict';

const { dismissRuntimeErrors, reportRuntimeError } = require('react-error-overlay');

module.exports = {
  clearRuntimeErrors: dismissRuntimeErrors,
  handleRuntimeError: reportRuntimeError,
};
